module.exports = __webpack_public_path__ + "static/car-writeup-96628ae75217fea60da0acd259b48082.pdf";